module.exports = __webpack_public_path__ + "img/car-audi.a2879f33.jpg";